import {
  getTheme,
  IButtonStyles,
  IconButton,
  IIconProps,
  IPalette,
  IStackStyles,
  Modal,
  Stack,
  Text
} from '@fluentui/react';
import React from 'react';

const keyboardShortcutHeaderStyles = (palette: IPalette): IStackStyles => {
  return {
    root: {
      backgroundColor: palette.neutralLighter,
      width: '300px',
      height: '200px',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '2px'
    }
  };
};

const shortcutDescriptionContainerStyles: IStackStyles = {
  root: { width: '300px', height: '200px' }
};

const cancelIcon: IIconProps = { iconName: 'Cancel' };

const shortcutDescriptionStyles = (palette: IPalette): IStackStyles => {
  return {
    root: {
      backgroundColor: palette.neutralLighter,
      height: '50px',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: '10px',
      paddingRight: '5px'
    }
  };
};

const shortcutStyles = (palette: IPalette): IStackStyles => {
  return {
    root: {
      borderRadius: '8px',
      padding: '5px 10px',
      marginRight: '5px',
      minWidth: '32px',
      textAlign: 'center',
      backgroundColor: palette.neutralLight
    }
  };
};

const iconButtonStyles = (palette: IPalette): Partial<IButtonStyles> => {
  return {
    root: {
      margin: '2px 2px 2px auto'
    },
    rootHovered: {
      color: palette.neutralDark
    }
  };
};

export interface KeyboardShortcutModalProps {
  isModalVisible: boolean;
  setIsModalVisible: (boolean) => void;
}

export const KeyboardShortcutModal: React.FunctionComponent<KeyboardShortcutModalProps> = props => {
  const { palette } = getTheme();

  return (
    <Modal
      titleAriaId="KeybodardModalTitle"
      isOpen={props.isModalVisible}
      onDismiss={() => props.setIsModalVisible(false)}
    >
      <Stack style={{ backgroundColor: palette.neutralLighter, marginBottom: '2px' }}>
        <IconButton
          styles={iconButtonStyles(palette)}
          iconProps={cancelIcon}
          ariaLabel="Close popup modal"
          onClick={() => props.setIsModalVisible(false)}
        />
      </Stack>
      <Stack horizontal>
        <Stack styles={keyboardShortcutHeaderStyles(palette)}>
          <Text as={'h2'} id="KeybodardModalTitle" variant={'large'}>
            Keyboard shortcuts
          </Text>
        </Stack>
        <Stack styles={shortcutDescriptionContainerStyles}>
          <Stack horizontal styles={shortcutDescriptionStyles(palette)} style={{ marginBottom: '2px' }}>
            <Text variant={'large'}>Select</Text>
            <Stack horizontal>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                Alt
              </Text>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                S
              </Text>
            </Stack>
          </Stack>
          <Stack horizontal styles={shortcutDescriptionStyles(palette)} style={{ marginBottom: '2px' }}>
            <Text variant={'large'}>Apply opinion</Text>
            <Stack horizontal>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                Alt
              </Text>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                N
              </Text>
            </Stack>
          </Stack>
          <Stack horizontal styles={shortcutDescriptionStyles(palette)} style={{ marginBottom: '2px' }}>
            <Text variant={'large'}>Next image</Text>
            <Stack horizontal>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                Alt
              </Text>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                .
              </Text>
            </Stack>
          </Stack>
          <Stack horizontal styles={shortcutDescriptionStyles(palette)}>
            <Text variant={'large'}>Previous image</Text>
            <Stack horizontal>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                Alt
              </Text>
              <Text variant={'large'} styles={shortcutStyles(palette)}>
                ,
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Modal>
  );
};
